import React from 'react';
import PortButton from '../PortButton';
import { getPatchPanelPortIndex } from '../portLayout';
import { enhancedTheme } from '../utils';

const PatchPanel = ({
  ports,
  selectedPortId,
  connectedPortIds,
  onPortClick,
  onRegisterAnchor,
}) => {
  const slots = Array.from({ length: 24 }, () => null);
  ports.forEach((port) => {
    const idx = getPatchPanelPortIndex(port);
    if (idx != null) slots[idx] = port;
  });

  return (
    <div style={{ width: '100%' }}>
      <div
        style={{
          fontSize: 11,
          fontWeight: 600,
          marginBottom: 6,
          color: enhancedTheme.sectionLabel,
        }}
      >
        Patch Panel — 24 ports
      </div>
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(12, 13px)',
          gap: 3,
          padding: 8,
          background: '#fafafa',
          border: '1px solid #d9d9d9',
          borderRadius: 4,
        }}
      >
        {slots.map((port, i) => (
          <PortButton
            key={port?._id || `empty-${i}`}
            port={port}
            slotNumber={i + 1}
            label={`PP-${i + 1}`}
            selected={port && String(selectedPortId) === String(port._id)}
            connected={port && connectedPortIds.has(String(port._id))}
            registered={Boolean(port)}
            onClick={onPortClick}
            onRegisterAnchor={onRegisterAnchor}
            size={13}
          />
        ))}
      </div>
    </div>
  );
};

export default PatchPanel;
